export default __webpack_public_path__ + "static/media/7.69c40692.png";